var _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon4, _path10, _path11, _path12, _path13, _path14, _path15, _polygon5, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPv0HendikepovaniWebLoga512X512PxMdcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.09 197.82 100.65 197.82 139.44 236.61 61.87 236.61 23.09 197.82",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.09 275.39 61.87 314.18 139.44 314.18 178.22 275.39 139.44 236.61 100.65 275.39 23.09 275.39",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.22 215.14 183.24 215.14 189.88 232.73 196.4 215.14 201.41 215.14 201.41 236.31 198.37 236.31 198.37 217.99 198.31 217.99 191.3 236.31 188.33 236.31 181.32 217.99 181.26 217.99 181.26 236.31 178.22 236.31 178.22 215.14",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m208.29,220.84h2.85v15.47h-2.85v-15.47Zm3.03-3.46h-3.21v-3.22h3.21v3.22Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m217.73,220.84h2.76v2.46h.06c.85-1.76,2.91-2.82,5.07-2.82,4.01,0,5.8,2.49,5.8,6.65v9.19h-2.85v-8.01c0-3.61-.79-5.37-3.27-5.52-3.25,0-4.71,2.61-4.71,6.38v7.16h-2.85v-15.47Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m238,220.84h2.85v15.47h-2.85v-15.47Zm3.03-3.46h-3.22v-3.22h3.22v3.22Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m246.28,233.28c1.13.73,2.73,1.09,3.55,1.09,1.31,0,2.91-.55,2.91-2.22,0-2.82-6.7-2.58-6.7-6.92,0-3.22,2.39-4.77,5.46-4.77,1.33,0,2.42.27,3.55.61l-.24,2.49c-.63-.39-2.33-.79-3-.79-1.45,0-2.73.61-2.73,1.88,0,3.15,6.71,2.24,6.71,7.19,0,3.31-2.64,4.82-5.41,4.82-1.45,0-2.94-.15-4.25-.85l.15-2.55Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m268.82,223.15h-4.09v8.47c0,1.79,1.09,2.76,2.39,2.76.88,0,1.52-.27,1.94-.55v2.43c-.64.18-1.52.43-2.42.43-2.95,0-4.77-1.4-4.77-4.49v-9.04h-3.49v-2.31h3.49v-3.58l2.85-.91v4.49h4.09v2.31Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m283.78,227.09c0-2.37-1.4-4.31-3.86-4.31-2.79,0-3.95,2.31-4.16,4.31h8.02Zm1.84,8.58c-1.09.4-2.33,1-4.88,1-5.49,0-8.01-3.34-8.01-8.37,0-4.58,2.88-7.83,7.24-7.83,5.16,0,6.83,3.76,6.83,8.74h-11.05c0,3.07,2.4,5.16,5.1,5.16,1.88,0,4.07-.97,4.76-1.55v2.85Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m292,220.84h2.67v2.4h.06c.76-1.61,2.4-2.76,4.03-2.76.86,0,1.28.09,1.89.21v2.55c-.52-.22-1.1-.27-1.58-.27-2.55,0-4.22,2.43-4.22,6.31v7.04h-2.85v-15.47Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m303.01,233.28c1.13.73,2.73,1.09,3.56,1.09,1.3,0,2.91-.55,2.91-2.22,0-2.82-6.7-2.58-6.7-6.92,0-3.22,2.4-4.77,5.46-4.77,1.33,0,2.42.27,3.55.61l-.24,2.49c-.64-.39-2.34-.79-3-.79-1.46,0-2.74.61-2.74,1.88,0,3.15,6.71,2.24,6.71,7.19,0,3.31-2.65,4.82-5.4,4.82-1.46,0-2.95-.15-4.25-.85l.15-2.55Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m325.25,223.15h-4.09v8.47c0,1.79,1.09,2.76,2.4,2.76.88,0,1.52-.27,1.94-.55v2.43c-.64.18-1.52.43-2.43.43-2.94,0-4.76-1.4-4.76-4.49v-9.04h-3.49v-2.31h3.49v-3.58l2.85-.91v4.49h4.09v2.31Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "336.06 236.31 332.66 236.31 327.1 220.84 330.24 220.84 334.42 233.46 334.48 233.46 338.76 220.84 341.61 220.84 336.06 236.31",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m351.71,234.37c3.34,0,4.83-3.03,4.83-5.79,0-2.94-1.79-5.8-4.83-5.8s-4.86,2.85-4.86,5.8c0,2.76,1.49,5.79,4.86,5.79m0-13.9c4.71,0,7.86,3.4,7.86,8.1,0,4.43-3.21,8.1-7.86,8.1s-7.89-3.67-7.89-8.1c0-4.7,3.16-8.1,7.89-8.1Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m380.84,234.37c3.22,0,4.55-3.19,4.55-5.76,0-2.88-1.49-5.83-4.58-5.83s-4.31,2.92-4.25,5.74c-.06,2.43,1.21,5.86,4.28,5.86m4.67-.24h-.06c-.75,1.15-2.52,2.55-5.28,2.55-4.68,0-6.65-4.16-6.65-8.37s2.19-7.83,6.68-7.83c2.7,0,4.25,1.06,5.13,2.49h.05v-9.4h2.86v22.75h-2.73v-2.18Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m400.56,234.37c3.34,0,4.83-3.03,4.83-5.79,0-2.94-1.79-5.8-4.83-5.8s-4.86,2.85-4.86,5.8c0,2.76,1.48,5.79,4.86,5.79m0-13.9c4.71,0,7.86,3.4,7.86,8.1,0,4.43-3.21,8.1-7.86,8.1s-7.89-3.67-7.89-8.1c0-4.7,3.15-8.1,7.89-8.1Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m420.28,222.78c-3.1,0-4.58,2.95-4.58,5.83,0,2.58,1.34,5.76,4.55,5.76s4.34-3.43,4.28-5.86c.06-2.79-1.15-5.74-4.25-5.74m-7.43-1.94h2.73v2.18h.06c.76-1.15,2.52-2.55,5.25-2.55,4.49,0,6.68,3.67,6.68,7.83s-1.98,8.37-6.65,8.37c-2.72,0-4.27-1.06-5.16-2.49h-.06v8.49h-2.85v-21.84Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m432.75,220.84h2.67v2.4h.06c.76-1.61,2.4-2.76,4.03-2.76.86,0,1.28.09,1.88.21v2.55c-.51-.22-1.09-.27-1.57-.27-2.55,0-4.22,2.43-4.22,6.31v7.04h-2.85v-15.47Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m452.6,228.94c-.6,0-1.21-.06-1.82-.06-1.55,0-5.37.24-5.37,2.98,0,1.64,1.58,2.52,2.88,2.52,2.82,0,4.31-1.76,4.31-4.07v-1.36Zm-8.47-7.01c1.43-.85,3.13-1.46,5.1-1.46,4.43,0,6.22,2.19,6.22,6.4v6.4c0,1.76.06,2.58.12,3.03h-2.68v-2h-.06c-.67.94-2.19,2.37-4.79,2.37-3.34,0-5.67-1.46-5.67-4.82,0-3.88,4.24-5.1,7.18-5.1,1.13,0,1.91,0,3.04.06,0-2.67-.97-4.04-3.82-4.04-1.61,0-3.34.61-4.49,1.58l-.16-2.43Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.74 236.31 464.34 236.31 458.79 220.84 461.91 220.84 466.09 233.46 466.16 233.46 470.44 220.84 473.29 220.84 467.74 236.31",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m475.5,240.5c.37.12.85.24,1.34.24,2.55,0,3.4-3.52,3.4-3.82,0-.33-.37-1.12-.54-1.64l-5.25-14.44h3.12l4.16,12.8h.06l4.25-12.8h2.88l-5.7,15.81c-1.06,2.97-2.19,6.4-5.95,6.4-.91,0-1.42-.12-1.94-.21l.18-2.34Z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPv0HendikepovaniWebLoga512X512PxMdcr);
export default __webpack_public_path__ + "static/media/PV0-Hendikepovani-web-loga-512x512px-MDCR.e1370a2ec4f066e463fa20006e51a2bc.svg";
export { ForwardRef as ReactComponent };